module.exports = __webpack_public_path__ + "static/courses-01-667fc72fe28b5f06beee8eee7bba3742.jpg";